// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalLayout_title__e4Ec3"};